import type {IntlShape} from 'react-intl';
import {AGENT_STARTED_BY, type AgentDeclaration, type AgentResult, type AgentStartedBy} from './agentDeclaration';

export const AGENTIC_WORKERS_MESSAGE = {
	BUTTON_WORKING: 'agentic_workers.button.working',
	BUTTON_STOP: 'agentic_workers.button.stop',
	BUTTON_WORKING_NAME: 'agentic_workers.button.working_name',
	MENU_RUN: 'agentic_workers.menu.run',
	MENU_RUNNING: 'agentic_workers.menu.running',
	MENU_SCHEDULE: 'agentic_workers.menu.schedule',
	MENU_PAST_RUNS: 'agentic_workers.menu.past_runs',
	BADGE_WAITING: 'agentic_workers.badge.waiting',
	TOAST_RUN_STOPPED: 'agentic_workers.toast.run_stopped',
	TOAST_RESULT_DELETED: 'agentic_workers.toast.result_deleted',
	TOAST_RESULT_HIDDEN: 'agentic_workers.toast.result_hidden',
	TOAST_ALREADY_DELETED: 'agentic_workers.toast.already_deleted',
	TOAST_ALREADY_ACTED: 'agentic_workers.toast.already_acted',
	TOAST_SOMEONE: 'agentic_workers.toast.someone',
	ROW_ACTION_WORKING: 'agentic_workers.row_action.working',
	ROW_ACTION_READY: 'agentic_workers.row_action.ready',
	ROW_ACTION_STOP: 'agentic_workers.row_action.stop',
	ROW_ACTION_STOP_PAGE_RUN: 'agentic_workers.row_action.stop_page_run',
	ROW_ACTION_READY_MENU: 'agentic_workers.row_action.ready_menu',
	PANEL_LABEL: 'agentic_workers.panel.label',
	RESULT_REVIEW: 'agentic_workers.result.review',
	RESULT_DELETE: 'agentic_workers.result.delete',
	PANEL_HIDE: 'agentic_workers.panel.hide',
	PANEL_LATER: 'common.later',
	PANEL_TITLE: 'agentic_workers.panel.title',
	PANEL_DATE_LINE: 'agentic_workers.panel.date_line',
	PANEL_RUN_JUST_NOW: 'agentic_workers.panel.run_just_now',
	PANEL_RUN_AT: 'agentic_workers.panel.run_at',
	FAILED_TITLE: 'agentic_workers.failed.title',
	FAILED_RETRY: 'agentic_workers.failed.retry',
	FAILED_REASON_TIMED_OUT: 'agentic_workers.failed.reason_timed_out',
	FAILED_REASON_UNKNOWN: 'agentic_workers.failed.reason_unknown',
	STATUS_LINE_NONE_WAITING: 'agentic_workers.status_line.none_waiting',
	STATUS_LINE_RAN_JUST_NOW: 'agentic_workers.status_line.ran_just_now',
	STATUS_LINE_RAN_AT: 'agentic_workers.status_line.ran_at',
	STATUS_LINE_SCHEDULE_OFF: 'agentic_workers.status_line.schedule_off',
	PAST_RUNS_SEARCH: 'agentic_workers.past_runs.search',
	PAST_RUNS_FILTER_LABEL: 'agentic_workers.past_runs.filter_label',
	PAST_RUNS_ALL: 'agentic_workers.past_runs.all',
	PAST_RUNS_NEEDS_REVIEW: 'agentic_workers.past_runs.needs_review',
	PAST_RUNS_DELETED: 'agentic_workers.past_runs.deleted',
	PAST_RUNS_FAILED: 'agentic_workers.past_runs.failed',
	STARTED_BY_MANUAL: 'agentic_workers.started_by.manual',
	STARTED_BY_MANUAL_BY: 'agentic_workers.started_by.manual_by',
	STARTED_BY_SCHEDULE: 'agentic_workers.started_by.schedule',
	PAST_RUNS_FOUND_JOINED: 'agentic_workers.past_runs.found_joined',
	PAST_RUNS_TODAY_AT: 'agentic_workers.past_runs.today_at',
	PAST_RUNS_DATE_AT: 'agentic_workers.past_runs.date_at',
	PAST_RUNS_WAITING_FOR_YOU: 'agentic_workers.past_runs.waiting_for_you',
	PAST_RUNS_ACTED_JUST_NOW: 'agentic_workers.past_runs.acted_just_now',
	PAST_RUNS_ACTED_AT: 'agentic_workers.past_runs.acted_at',
	PAST_RUNS_NO_MATCH: 'agentic_workers.past_runs.no_match',
	PAST_RUNS_CLEAR_FILTERS: 'agentic_workers.past_runs.clear_filters',
	FAILED_OPEN_RUN: 'agentic_workers.failed.open_run',
	NOTIFICATION_LINE: 'agentic_workers.notification.line',
	NOTIFICATION_UNKNOWN_AGENT: 'agentic_workers.notification.unknown_agent',
} as const;

// What started a run: "Run manually by ‹name›", "Run manually" with no name, or "On a schedule".
// Past Runs and the bell's notification both say it.
export const describeStartedBy = (startedBy: AgentStartedBy, startedByName: string | null, intl: IntlShape): string => {
	if (startedBy === AGENT_STARTED_BY.SCHEDULE) {
		return intl.formatMessage({id: AGENTIC_WORKERS_MESSAGE.STARTED_BY_SCHEDULE});
	}
	if (startedByName === null) {
		return intl.formatMessage({id: AGENTIC_WORKERS_MESSAGE.STARTED_BY_MANUAL});
	}
	return intl.formatMessage({id: AGENTIC_WORKERS_MESSAGE.STARTED_BY_MANUAL_BY}, {name: startedByName});
};

// The accept button's words: the agent's single label for one row, its bulk label with the count for more.
export const describeAcceptLabel = (declaration: AgentDeclaration, result: AgentResult, {formatMessage}: IntlShape): string =>
	result.rows.length === 1
		? formatMessage(declaration.acceptLabel.single)
		: formatMessage(declaration.acceptLabel.bulk, {count: result.rows.length});
